import { Box, Typography } from '@mui/material';
import React, { FC } from 'react';
import colors from 'src/styles/equalution/colors';
import { Button } from 'reactstrap';
import CheckIcon from '@mui/icons-material/Check';
import { useAppSelector } from 'src/store/hooks';
import CoachingIcon from 'src/assets/icons/coaching.svg';
import { isUserFromAustralia } from 'src/lib/utils';

interface SignupNutritionCoachingProps {
  onCtaClick?: () => void;
  price?: string | number;
  isNutritionCoachingAdded?: boolean;
  priceSuffix?: string;
}

export const SignupNutritionCoaching: FC<SignupNutritionCoachingProps> = ({
  price = '$XX',
  onCtaClick,
  isNutritionCoachingAdded,
  priceSuffix = '',
}) => {
  const isPaymentProcessing = useAppSelector(
    state => state.payment.isPaymentProcessing
  );

  // Only show personal coaching to Australian users
  if (!isUserFromAustralia()) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '16px',
        textAlign: 'center',
        backgroundColor: colors.WHITE,
        borderRadius: '20px',
      }}>
      <Box
        sx={{
          backgroundColor: colors.WHITE,
          padding: '16px',
          borderRadius: '20px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '12px',
        }}>
        <Box mb={0}>
          <img src={CoachingIcon} alt="Coach Icon" width={40} height={40} />
        </Box>
        <Typography
          sx={{
            fontSize: '20px',
            fontWeight: 700,
            color: colors.SALAD,
            lineHeight: '0px',
          }}>
          1:1 Nutrition Coaching
        </Typography>
        <Typography
          sx={{
            fontSize: '20px',
            fontWeight: 700,
            color: colors.OFF_BLACK,
          }}>
          ${typeof price === 'number' ? Number(price).toFixed(0) : price}
          {priceSuffix}
        </Typography>
        <Typography
          sx={{
            fontSize: '15px',
            fontWeight: 400,
            color: colors.OFF_BLACK,
            lineHeight: '0px',
          }}>
          (recommended)
        </Typography>
        <Typography
          sx={{
            fontSize: '15px',
            fontWeight: 300,
            color: colors.OFF_BLACK,
            lineHeight: '20px',
            marginTop: '12px',
            marginBottom: '4px',
          }}>
          Reach your goals faster with a qualified personal nutrition coach for
          expert guidance and consistent support.
        </Typography>
        <Button
          disabled={isNutritionCoachingAdded || isPaymentProcessing}
          onClick={onCtaClick}
          style={{
            height: '52px',
            fontWeight: 600,
            fontSize: '16px',
            width: '100%',
            backgroundColor: isNutritionCoachingAdded
              ? `${colors.OFF_BLACK}4D`
              : colors.OFF_BLACK,
            border: 'none',
            padding: 0,
          }}>
          {isNutritionCoachingAdded && (
            <CheckIcon
              sx={{ color: colors.WHITE, fontSize: 20, mb: -0.5, mr: 1 }}
            />
          )}
          {isNutritionCoachingAdded
            ? 'Added a nutrition coach'
            : 'Add a nutrition coach'}
        </Button>
      </Box>
    </Box>
  );
};
